import { z } from 'zod';

import { questionAnswerTopRightSchema } from './topRightTypes/questionAnswerTopRightSchema';
import { textTopRightSchema } from './topRightTypes/textTopRightSchema';

export const topRightObjectSchema = z.union([textTopRightSchema, questionAnswerTopRightSchema]);

export type TopRightItemType = z.infer<typeof topRightObjectSchema>;
